import { useState } from "react";
import { faqs } from "../data";

export default function FaqSection() {
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <section id="faq" className="scroll-mt-24 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
          <div className="lg:col-span-4">
            <p className="text-primary-600 font-semibold tracking-wide text-sm">FAQ · 常见疑问</p>
            <h2 className="mt-2 font-heading text-3xl md:text-4xl font-extrabold text-foreground-950">
              关于搭讪争议，你常问这些
            </h2>
            <p className="mt-3 text-foreground-600 leading-7">
              我们把网友最关心的隐私边界、下架原因、维权方式等问题集中作答。每一条都可以直接引用与转发。
            </p>
            <div className="mt-6 inline-flex items-center gap-2 text-sm text-foreground-500">
              <i className="ri-chat-check-line text-primary-500 text-lg"></i>
              共整理 {faqs.length} 个高频问题
            </div>
          </div>

          <div className="lg:col-span-8 space-y-3">
            {faqs.map((f, i) => {
              const open = openIdx === i;
              return (
                <div
                  key={f.q}
                  className={`rounded-2xl border overflow-hidden transition ${
                    open ? "bg-background-50 border-primary-300" : "bg-background-50 border-background-200"
                  }`}
                >
                  <button
                    onClick={() => setOpenIdx(open ? -1 : i)}
                    aria-expanded={open}
                    className="w-full flex items-center justify-between gap-4 p-5 text-left"
                  >
                    <h3 className={`font-heading text-[17px] font-bold leading-snug ${open ? "text-primary-700" : "text-foreground-950"}`}>
                      {f.q}
                    </h3>
                    <span
                      className={`shrink-0 w-8 h-8 rounded-full flex items-center justify-center border transition ${
                        open ? "bg-primary-500 border-primary-500 text-background-50" : "border-background-300 text-foreground-600"
                      }`}
                    >
                      <i className={`ri-${open ? "subtract-line" : "add-line"}`}></i>
                    </span>
                  </button>
                  {open && (
                    <p className="px-5 pb-5 text-[15px] leading-7 text-foreground-700">{f.a}</p>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}